import { Button, Card, Col, Form, Input, message, Row } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_METHODS } from "../constants";
import { isEmpty } from "../generalFunctions";
import useApi from "../hooks/useApi";
import ServerDownResult from "./common/ServerDownResult";

function Login() {
  const [response, request] = useApi("/admin/auth", null, API_METHODS.POST);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  // Check if admin is already logged in on component mount
  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const user = localStorage.getItem("user");

    if (authToken && user) {
      try {
        const userData = JSON.parse(user);
        // Verify it's admin user (you can add more validation here)
        if (userData && (userData.role === "1" || userData.role === 1)) {
          // Admin is already logged in, redirect to dashboard
          navigate("/portal/dashboard");
        }
      } catch (error) {
        // If user data is corrupted, clear localStorage
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
      }
    }
  }, [navigate]);

  const LoginClicked = () => {
    form.validateFields().then((values) => {
      request(values);
    });
  };

  // Handle login response
  useEffect(() => {
    if (!isEmpty(response) && !response.isLoading) {
      if (response.data && response.data.token) {
        // SUCCESS: Save token and navigate
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.admin));

        messageApi.open({
          type: "success",
          content:
            "🙏 Login successful! Welcome to Mahalaxmi Puja Admin Portal",
          duration: 2,
        });

        setTimeout(() => {
          navigate("/portal/dashboard");
        }, 1000);
      } else if (response.error) {
        // ERROR: Show error message
        messageApi.open({
          type: "error",
          content:
            response.error ||
            "❌ Invalid credentials. Please check your username and password.",
          duration: 4,
        });
      }
    }
  }, [response, navigate, messageApi]);

  return (
    <>
      {contextHolder}
      {!isEmpty(response) ? (
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{
            minHeight: "100vh",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          }}
        >
          <Col xs={20} sm={16} md={12} lg={10} xl={8}>
            <Card
              title={
                <div style={{ textAlign: "center", fontSize: "18px" }}>
                  🕉️ Mahalaxmi Puja - Admin Login
                </div>
              }
              style={{
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                borderRadius: "12px",
              }}
            >
              <Form layout="vertical" onFinish={LoginClicked} form={form}>
                <Form.Item
                  label="Username/Email"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please input your username/email",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter your username or email"
                    size="large"
                  />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                    { max: 15 },
                  ]}
                >
                  <Input.Password
                    placeholder="Enter your password"
                    size="large"
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={response.isLoading}
                    size="large"
                    style={{
                      width: "100%",
                      background: "linear-gradient(45deg, #f97316, #dc2626)",
                      border: "none",
                    }}
                  >
                    {response.isLoading ? "Signing In..." : "Sign In"}
                  </Button>
                </Form.Item>
              </Form>

              {/* Optional: Show error message */}
              {response.isError && (
                <div
                  style={{
                    color: "#ff4d4f",
                    textAlign: "center",
                    marginTop: "10px",
                    fontSize: "14px",
                  }}
                >
                  Login failed. Please check your credentials.
                </div>
              )}
            </Card>
          </Col>
        </Row>
      ) : (
        <ServerDownResult />
      )}
    </>
  );
}

export default Login;
